import React from 'react';
import { Typography, Box } from '@mui/joy';

const ClientMap = () => {
  return (
    <Box>
      <Typography level="h4" gutterBottom>
        Project Map
      </Typography>
      <Typography level="body-md">
        An interactive map of your project locations will be displayed here.
      </Typography>
    </Box>
  );
};

export default ClientMap;
